import {ProjectService} from '../Services'
import {Project, Spinner, Storage, UUID} from './index'

const PROJECT_D4D = 1
const PROJECT_JOB_SHADOW = 2
const PROJECT_BE_ENTREPRENEURIAL = 3

const PROJECT_TOTAL_PAGE = {}
PROJECT_TOTAL_PAGE[PROJECT_D4D] = 20
PROJECT_TOTAL_PAGE[PROJECT_JOB_SHADOW] = 23
PROJECT_TOTAL_PAGE[PROJECT_BE_ENTREPRENEURIAL] = 24

const PROJECT_PREFIX = {}
PROJECT_PREFIX[PROJECT_D4D] = ""
PROJECT_PREFIX[PROJECT_JOB_SHADOW] = "js"
PROJECT_PREFIX[PROJECT_BE_ENTREPRENEURIAL] = "be"

const PROJECT_TYPE = []
PROJECT_TYPE[PROJECT_D4D] = 'Design for Delight'
PROJECT_TYPE[PROJECT_JOB_SHADOW] = 'JA Job Shadow'
PROJECT_TYPE[PROJECT_BE_ENTREPRENEURIAL] = 'JA Be Entrepreneurial'

const differentVersion = (versionCurrent, versionNew) => {
    return versionNew !== versionCurrent
};

const updateProject = (project) => {

    return ProjectService.updateProject(project).then(response => {
        return Promise.resolve(response.project)
    }).catch(err => {
        if (err.message) {
            return Promise.reject(`Server error: ${err.message}`)
        } else {
            return Promise.reject('Unexpected server error')
        }
    })
}

const getProject = (projectId) => {
    return ProjectService.getProject(projectId).then(response => {
        const project = response.project
        project.userId = Storage.getUser().id

        return Promise.resolve(response.project)
    }).catch(error => {
        if (error.message) {
            return Promise.reject(`Server error: ${error.message}`)
        } else {
            return Promise.reject('Unexpected server error')
        }
    })
}

const syncProject = (syncProject, projectIndex, isOffline = false, keepVersion = false) => {
    const response = {index: projectIndex, project: null}
    syncProject['hasDifferenceVersion'] = false

    if (keepVersion) {
        syncProject['keepVersion'] = keepVersion
    }

    return new Promise(async (resolve, reject) => {

        if (isOffline) {
            Storage.replaceProject(projectIndex, syncProject);
            response.project = Storage.getProject(projectIndex);

            resolve(response)
        } else {
            Spinner.start();

            if (UUID.isUUID(syncProject.projectId)) {
                return updateProject(syncProject).then(p => {

                    Storage.replaceProject(projectIndex, p);
                    response.project = Storage.getProject(projectIndex);
                    Spinner.stop();
                    resolve(response);
                }).catch(error => {
                    Spinner.stop();
                    reject(`Server error: ${error.message}`)
                })
            } else {
                const project = await getProject(syncProject.projectId)

                if (differentVersion(project.version, syncProject.version) && !keepVersion) {
                    syncProject['hasDifferenceVersion'] = true

                    Storage.replaceProject(projectIndex, syncProject)
                    response.project = Storage.getProject(projectIndex);

                    Spinner.stop();
                    resolve(response);
                } else {
                    return updateProject(syncProject).then(p => {
                        Storage.replaceProject(projectIndex, p);
                        response.project = Storage.getProject(projectIndex);
                        Spinner.stop();

                        resolve(response);
                    }).catch(error => {
                        Spinner.stop();
                        reject(`Server error: ${error.message}`)
                    })
                }
            }
        }
    }).catch(error => {
        Spinner.stop();
        throw error;
    })
}

export default {
    PROJECT_D4D,
    PROJECT_JOB_SHADOW,
    PROJECT_BE_ENTREPRENEURIAL,
    PROJECT_TYPE,
    PROJECT_TOTAL_PAGE,
    PROJECT_PREFIX,
    getProject,
    syncProject,
    updateProject,
    saveProject(isNewProject, projectIndex, type, name, problem, customer, isOffline = false, isGuest = false) {
        return new Promise(function (resolve, reject) {
            let projectData = {}

            if(isGuest) { isOffline  = true }

            if (isNewProject) {
                const {index, project} = Storage.createProject(type, name, problem, customer)
                projectIndex = index
                projectData = project
            } else {
                projectData = Storage.updateProject(projectIndex, type, name, problem, customer, isOffline)
            }
            const projectImages = Storage.getImagesByProjectId(projectData.projectId)
            projectData = { ...projectData, projectImages }

            syncProject(projectData, projectIndex, isOffline).then(response => {
                resolve(response)
            }).catch(error => {
                reject(`Unexpected error: ${error}`)
            })
        })
    },
    getProjectImage(projectId, stepName) {
        return ProjectService.getProjectImage(projectId, stepName).then(response => {
            return Promise.resolve(response.success ? response.projectImage.image : null)
        }).catch(error => {
            if (error.message) {
                return Promise.reject(`Server error: ${error.message}`)
            } else {
                return Promise.reject('Unexpected server error')
            }
        })
    },
    saveProjectImage(projectId, stepName, payload) {
        return ProjectService.saveProjectImage(projectId, stepName, payload).then(response => {
            return Promise.resolve(response.success ? response.projectImage.image : null)
        }).catch(error => {
            if (error.message) {
                return Promise.reject(`Server error: ${error.message}`)
            } else {
                return Promise.reject('Unexpected server error')
            }
        })
    },
    saveProjectStep(projectIndex, stepName, stepNumber, form={}, isOffline = false, isGuest = false) {
        return new Promise(function (resolve, reject) {
            if(isGuest) { isOffline  = true }
            const project = Storage.updateProjectForm(projectIndex, stepName, stepNumber, form, isOffline)
            const projectImages = Storage.getImagesByProjectId(project.projectId)
            const projectData = { ...project, projectImages }

            syncProject(projectData, projectIndex, isOffline).then(response => {
                resolve(response)
            }).catch(error => {
                reject(`Unexpected error: ${error}`)
            })
        })
    },
    getProjectURL(index, type, lastStep) {
        const response = {name: null, params: {index}}
        const projects = [Project.PROJECT_JOB_SHADOW, Project.PROJECT_BE_ENTREPRENEURIAL, Project.PROJECT_D4D]

        if (projects.includes(type) || type === 0) {
            if (lastStep === PROJECT_TOTAL_PAGE[type] - 1) {
                response.name = (PROJECT_PREFIX[type] ? PROJECT_PREFIX[type] + "_" : "") + 'edit_project'
            } else {
                response.name = (PROJECT_PREFIX[type] ? PROJECT_PREFIX[type] + "_" : "") + 'before_you_continue'
            }
        }

        return response
    },
    deleteProject(projectIndex, projectId) {
        return new Promise(function (resolve, reject) {
            const user = Storage.getUser()
            Storage.deleteProject(projectIndex)

            if (navigator.onLine) {
                Spinner.start()
                ProjectService.deleteProject(user.id, projectId).then(response => {
                    Spinner.stop()
                    resolve(projectIndex) // stored: local and server
                }).catch(err => {
                    Spinner.stop()
                    if (err.message) {
                        reject(`Server error: ${err.message}`)
                    } else {
                        reject('Unexpected server error')
                    }
                })
            } else {
                resolve(false) // stored: only local
            }
        })
    },
}
